import React from "react";
import './intro.css';
import bg from '../../assets/00.png';
import { FaInstagram, FaLine } from 'react-icons/fa';
import { TypeAnimation } from "react-type-animation";
import { motion } from 'framer-motion';
import { fadeIn } from './variants';
import { FaThreads } from "react-icons/fa6";

const Intro = () => {
    return (
        <section className="aja" id="intro">
            <div className="b">
                <div className="box">
                    {/* Text */}
                    <div className="c">
                        <motion.h1
                            variants={fadeIn('up', 0.3)}
                            initial='hidden'
                            whileInView={'show'}
                            viewport={{ once: false, amount: 0.7 }}
                            className="d">
                            <span>Justin</span>
                        </motion.h1>
                        <motion.div
                            variants={fadeIn('up', 0.4)}
                            initial='hidden'
                            whileInView={'show'}
                            viewport={{ once: false, amount: 0.7 }}
                            className="e">
                            <span className="f">I am a </span>
                            <TypeAnimation
                                sequence={[
                                    'Farm Manager',
                                    2000,
                                    'Orchard Manager',
                                    2000,
                                ]}
                                speed={50}
                                className="text-accent" wrapper="span" repeat={Infinity}
                            />
                        </motion.div>
                        <motion.p
                            variants={fadeIn('up', 0.5)}
                            initial='hidden'
                            whileInView={'show'}
                            viewport={{ once: false, amount: 0.7 }}
                            className="h">
                            A manager who is fully responsible for the planning, organizing, and overseeing the daily operations of a farm, plantation,
                            or livestock business in order to achieve production targets and profitability.
                        </motion.p>
                        <motion.div
                            variants={fadeIn('up', 0.6)}
                            initial='hidden'
                            whileInView={'show'}
                            viewport={{ once: false, amount: 0.7 }}
                            className="i">
                            <button className="btn">Contact Me</button>
                            <div className="social-media">
                                <a className="ja" href="https://line.me/ti/p/~justin">
                                    <FaLine style={{ width: '50px', height: '50px' }} />
                                </a>
                                <a className="ja" href="https://www.threads.com/@jongmyxong?xmt=AQF0Bw4CEojGM9ihj_luCfeGZahRi4AqSqr1RJm-5Uh58XU">
                                    <FaThreads style={{ width: '50px', height: '50px' }} />
                                </a>
                                <a className="ja" href="https://www.instagram.com/jongmyxong/">
                                    <FaInstagram style={{ width: '50px', height: '50px' }} />
                                </a>
                            </div>
                            {/* <a href="#" className="text-gradient btn-link">
                                My Profile
                            </a> */}
                        </motion.div>
                        <motion.div
                            variants={fadeIn('up', 0.7)}
                            initial='hidden'
                            whileInView={'show'}
                            viewport={{ once: false, amount: 0.7 }}
                            className="j">
                            <a className="ja" href="https://line.me/ti/p/~justin">
                                <FaLine style={{ width: '50px', height: '50px' }} />
                            </a>
                            <a className="ja" href="https://www.threads.com/@jongmyxong?xmt=AQF0Bw4CEojGM9ihj_luCfeGZahRi4AqSqr1RJm-5Uh58XU">
                                <FaThreads />
                            </a>
                            <a className="ja" href="https://www.instagram.com/jongmyxong/">
                                <FaInstagram />
                            </a>
                        </motion.div>
                    </div>
                    <motion.div
                        variants={fadeIn('up', 0.5)}
                        initial='hidden'
                        whileInView={'show'}
                        className="k">
                        <img src={bg} className="p" alt="" />
                    </motion.div>
                </div>
            </div>
        </section >
    )
}

export default Intro;
